import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class TaxAccessSyncLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.TaxAccessSyncSummaryLogSearchModel): Observable<Compliance.QueryResultModel<Core.TaxAccessSyncSummaryLogModel>> {
        return this.httpPost('/api/diagnostics/taxAccessSync/summary', searchModel);
    }

    getDetail(searchModel: Core.TaxAccessSyncDiagnosticsDetailSearchModel): Observable<Core.TaxAccessSyncDiagnosticsDetailModel> {
        return this.httpPost(`/api/diagnostics/taxAccessSync/detail`, searchModel);
    }
}
